import React, { useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import { useHistory, Link } from 'react-router-dom'

//modals
import LawCommentModal from '../../modals/LawComment'

//partials
import Result from './Result'

//images
import brand from '../../../assets/images/header/brand-white.png'
import arrowLeftIcon from '../../../assets/images/demo/left-arrow.png'
import arrowRightIcon from '../../../assets/images/demo/right-arrow.png'
import soundIcon from '../../../assets/images/demo/sound-icon.png'
import muteIcon from '../../../assets/images/demo/mute-icon.png'
import replаyIcon from '../../../assets/images/demo/replay-icon.png'
import commentIcon from '../../../assets/images/demo/comment-icon.png'

//sound
import sound from '../../../assets/images/demo/test/4-55.0/4-55.0.mp3'

//tes images
import singleImage from '../../../assets/images/demo/test/4-55.0/4.jpeg'
import firstImage from '../../../assets/images/demo/test/4-55.1/4.png'
import secondImage from '../../../assets/images/demo/test/4-55.1/3.png'
import thirdImage from '../../../assets/images/demo/test/4-55.1/2.png'
import fourthImage from '../../../assets/images/demo/test/4-55.1/1.png'

let voice

function Test() {
    const history = useHistory()

    const [state, setState] = useState({
        currentQuestion: 1,
        isAnswered: {
            1: false,
            2: false,
        },
        isCorrect: {
            1: false,
            2: false,
        },
        commentOverlay: false,
        commentModal: false,
        paused: false,
    })

    useEffect(() => {
        window.onload = function () {
            voice = document.getElementById('voice')
        }
    }, [window.onload])

    const handlePrevQuestion = () => {
        document.querySelector('#demoTest > div.body > ul > li.with-image').style.position = 'static'
        setState(prev => ({
            ...prev,
            currentQuestion: prev.currentQuestion - 1
        }))
    }

    const handleNextQuestion = () => {
        setState(prev => ({
            ...prev,
            currentQuestion: prev.currentQuestion + 1
        }))

        setTimeout(() => {
            document.querySelector('#demoTest > div.body > ul > li.with-image').style.position = 'absolute'
        }, 200)

        resetAudio()
    }

    const handleAnswer = e => {
        e.target.classList.add('selected')

        const correct = Number(e.target.getAttribute('data-correct'))

        setState(prev => ({
            ...prev,
            isAnswered: {
                ...prev.isAnswered,
                [state.currentQuestion]: true,
            },
            isCorrect: {
                ...prev.isCorrect,
                [state.currentQuestion]: correct,
            }
        }))

        !state.paused && voice.play()
    }

    const handleCommentModal = () => {
        setState(prev => {
            return {
                ...prev,
                commentOverlay: true
            }
        })

        setTimeout(() => {
            setState(prev => {
                return {
                    ...prev,
                    commentModal: true
                }
            })
        }, 50)
    }

    const handleCloseComment = () => {
        setState(prev => {
            return {
                ...prev,
                commentModal: false
            }
        })
        setTimeout(() => {
            setState(prev => {
                return {
                    ...prev,
                    commentOverlay: false
                }
            })
        }, 100)
    }

    const resetAudio = () => {
        voice.pause()
        voice.currentTime = 0
    }

    const toggleAudio = () => {
        setState(prev => ({
            ...prev,
            paused: prev.paused ? false : true,
        }))

        if (!state.paused) voice.pause()
    }



    const replayAudio = () => {
        voice.currentTime = 0
        voice.play()

        setState(prev => ({
            ...prev,
            paused: false,
        }))
    }

    const handleResult = () => {
        resetAudio()
        history.push({
            search: '?result',
        })
    }

    return (
        <section id="demoTest">
            <Result
                show={history.location.search == '?result'}
                answered={state.isCorrect[1] && state.isCorrect[2] ? 2 : state.isCorrect[1] || state.isCorrect[2] ? 1 : 0}
            />
            <LawCommentModal
                secondaryText='Пътен знак Г1 "Движение само направо след знака"'
                blur={state.commentOverlay}
                popup={state.commentModal}
                cancelCallback={handleCloseComment}
            />
            <div className="wrapper top">
                <Link to="/try" className="left">
                    <img src={brand} className="brand" />
                    <h1>
                        Авто Обучение
                    </h1>
                </Link>
            </div>
            <div className="stats">
                <div className="wrapper">
                    <ul className="left">
                        <li>
                            Въпрос {state.currentQuestion}
                        </li>
                        <li>
                            Верни 1
                        </li>
                        <li>
                            Точки 2
                        </li>
                    </ul>
                    <ul className="right">
                        <li>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="body">
                <ul className={`${state.currentQuestion == 2 ? 'to-second-step' : ''} wrapper`}>
                    <li className="with-image">
                        <h3>
                            Този пътен знак:
                        </h3>
                        <img src={singleImage} className="main-image" />
                        <ul
                            className={`answers`}
                            style={state.isAnswered[1] ? { pointerEvents: 'none' } : {}}
                        >
                            <li className={state.isAnswered[1] ? 'answered correct' : 'not-answered'}>
                                <span onClick={handleAnswer} data-correct="1">
                                    задължава водачите да се движат само направо след знака
                                </span>
                            </li>
                            <li className={state.isAnswered[1] ? 'answered' : 'not-answered'}>
                                <span onClick={handleAnswer}>
                                    сигнализира за еднопосочно движение след знака
                               </span>
                            </li>
                            <li className={state.isAnswered[1] ? 'answered' : 'not-answered'}>
                                <span onClick={handleAnswer}>
                                    указва посоката на пътя с предимство
                                </span>
                            </li>
                            {/* <li className={state.isAnswered[1] ? 'answered' : ''}>
                                <span onClick={handleAnswer}>
                                    препоръчва на водачите да се движат направо след знака
                                </span>
                            </li> */}
                        </ul>
                    </li>
                    <li>
                        <h3>
                            Кой пътен знак ви задължава да се движите само направо след него?
                        </h3>
                        <ul
                            className={`answers ${state.isAnswered[1] ? 'first-is-answered' : ''}`}
                            style={state.isAnswered[2] ? { pointerEvents: 'none' } : {}}
                        >
                            <li className={state.isAnswered[2] ? 'answered correct' : 'not-answered'}>
                                <span onClick={handleAnswer} data-correct="1">
                                    <img src={firstImage} />
                                </span>
                            </li>
                            <li className={state.isAnswered[2] ? 'answered' : 'not-answered'}>
                                <span onClick={handleAnswer}>
                                    <img src={secondImage} />
                                </span>
                            </li>
                            <li className={state.isAnswered[2] ? 'answered' : 'not-answered'}>
                                <span onClick={handleAnswer}>
                                    <img src={thirdImage} />
                                </span>
                            </li>
                            <li className={state.isAnswered[2] ? 'answered' : 'not-answered'}>
                                <span onClick={handleAnswer}>
                                    <img src={fourthImage} />
                                </span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="questions">
                <ul className={`${state.currentQuestion == 1 && state.isAnswered[1] ?
                    '' :
                    state.currentQuestion == 2 && state.isAnswered[2] ?
                        ''
                        :
                        'disabled'
                    } wrapper`}>
                    <li onClick={toggleAudio}>
                        <Button>
                            {state.paused ?
                                <img src={muteIcon} />
                                :
                                <img src={soundIcon} />
                            }
                        </Button>
                    </li>
                    <li onClick={replayAudio} >
                        <Button>
                            <img src={replаyIcon} />
                        </Button>
                    </li>
                    <li onClick={handleCommentModal}>
                        <Button>
                            <img src={commentIcon} />
                        </Button>
                    </li>
                </ul>
                <audio id="voice" autoPlay={false} src={sound} />
            </div>
            <div className="buttons">
                <Button
                    className={state.currentQuestion == 1 ? 'disabled' : ''}
                    onClick={handlePrevQuestion}
                >
                    <img src={arrowLeftIcon} />
                    Предишен
                </Button>
                {state.currentQuestion == 2 ?
                    <Button
                        className={`result-button ${state.isAnswered[1] && state.isAnswered[2] ? 'available' : 'disabled'}`}
                        onClick={handleResult}
                    >
                        Резултат
                    </Button>
                    :
                    <Button
                        className={state.currentQuestion == 2 ? 'disabled' : ''}
                        onClick={handleNextQuestion}
                    >
                        Следващ
                        <img src={arrowRightIcon} />
                    </Button>
                }
            </div>
        </section>
    )
}

export default Test